var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("调拨信息单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: { model: _vm.transVoucherInfo, rules: _vm.voucherInfo }
        },
        [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("调拨信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form flex col-2" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("调出部门")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "srcComName",
                        rules: { validator: _vm.checkNull, trigger: "blur" }
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.transVoucherInfo.srcComFullName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.transVoucherInfo,
                              "srcComFullName",
                              $$v
                            )
                          },
                          expression: "transVoucherInfo.srcComFullName"
                        }
                      }),
                      _vm._v(" "),
                      !_vm.taxRateChange && _vm.id == null
                        ? _c("i", {
                            staticClass:
                              "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                            on: { click: _vm.selectSrcBizUnitName }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.suiteMgmtEnabled &&
            _vm.transVoucherInfo.assetType != 2 &&
            _vm.id == null
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("套装调拨")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.id != null },
                              on: { change: _vm.changeSuitFalg },
                              model: {
                                value: _vm.transVoucherInfo.suitFlag,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.transVoucherInfo,
                                    "suitFlag",
                                    $$v
                                  )
                                },
                                expression: "transVoucherInfo.suitFlag"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("否")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v(
                    _vm._s(
                      _vm.transVoucherInfo.reserveFlag ? "预定说明" : "申请原因"
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "applyDesc",
                        rules: { validator: _vm.checkEmpty, trigger: "blur" }
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请填写调拨原因及数量说明",
                          disabled: _vm.taxRateChange,
                          type: "textarea",
                          resize: "both"
                        },
                        model: {
                          value: _vm.transVoucherInfo.applyDesc,
                          callback: function($$v) {
                            _vm.$set(_vm.transVoucherInfo, "applyDesc", $$v)
                          },
                          expression: "transVoucherInfo.applyDesc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.transVoucherInfo.suitFlag
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("资产信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-tip error fr font12" }, [
              _vm._v("提示:一次调拨数据最多2000条")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.transVoucherInfo.suitFlag && !_vm.taxRateChange && !_vm.srcCheck
        ? _c("div", { staticClass: "simple-row" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.showDeviceListDlg()
                      }
                    }
                  },
                  [
                    _vm.transVoucherInfo.reserveFlag
                      ? _c("span", [_vm._v("闲置资产选择")])
                      : _c("span", [_vm._v("通用选择")])
                  ]
                ),
                _vm._v(" "),
                !_vm.transVoucherInfo.suitFlag &&
                !_vm.taxRateChange &&
                !_vm.transVoucherInfo.reserveFlag
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.setDstInfo }
                      },
                      [_c("span", [_vm._v("批量选择调入机构")])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.transVoucherInfo.suitFlag,
              expression: "!transVoucherInfo.suitFlag"
            }
          ]
        },
        [
          _c("swb-shop-device-trans-voucher-item-scroll", {
            ref: "swb_shop_device_trans_voucher_item",
            attrs: {
              srcCheck: _vm.srcCheck,
              taxRateChange: _vm.taxRateChange,
              offline: _vm.offline,
              transItemList: _vm.transItemList,
              reloadItemInfo: _vm.reloadItemInfo,
              suitFlag: _vm.transVoucherInfo.suitFlag,
              srcComId: _vm.transVoucherInfo.srcComId,
              id: _vm.id
            },
            on: {
              getDevicesLength: _vm.getDevicesLength,
              "sync-src-Warehouse-device": _vm.deviceSetSrcWraehouse
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.id == null && _vm.transVoucherInfo.suitFlag,
              expression: "id == null && transVoucherInfo.suitFlag"
            }
          ]
        },
        [
          _c("swb-shop-device-suit-stock-trans-item-select", {
            ref: "item_device_suit_select",
            attrs: {
              taxRateChange: _vm.taxRateChange,
              suitFlag: _vm.transVoucherInfo.suitFlag,
              srcBizUnitId: _vm.transVoucherInfo.srcBizUnitId,
              deviceItemList: _vm.transItemList,
              dstBizUnitId: _vm.transVoucherInfo.dstBizUnitId
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "XX店号XX店XX设备调拨至XX店号XX店",
                  disabled: _vm.taxRateChange,
                  type: "textarea",
                  resize: "both"
                },
                model: {
                  value: _vm.transVoucherInfo.memo,
                  callback: function($$v) {
                    _vm.$set(_vm.transVoucherInfo, "memo", $$v)
                  },
                  expression: "transVoucherInfo.memo"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.transVoucherInfo.reserveFlag
        ? [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.showDialogFile()
                  }
                }
              },
              [_vm._v("上传")]
            ),
            _vm._v(" "),
            _vm.transVoucherInfo.fileList != null &&
            _vm.transVoucherInfo.fileList.length > 0
              ? _c(
                  "div",
                  { staticClass: "file-view-list" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _vm._l(_vm.transVoucherInfo.fileList, function(
                      fileInfo,
                      index
                    ) {
                      return [
                        _c("swb-file-item-li", {
                          attrs: {
                            trackKey: index,
                            fileName: fileInfo.name,
                            fileBrowseUrl: fileInfo.fileBrowseUrl,
                            fileDownloadUrl: fileInfo.fileBrowseUrl,
                            fileUuid: fileInfo.fileUuid,
                            deletable: true,
                            onDelete: _vm.deleteFile
                          }
                        })
                      ]
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary mr10",
            on: { click: _vm.prevStock }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        !_vm.autoApplyAndAudit &&
        _vm.checkActionPerm("apply", null, _vm.transVoucherInfo.srcComId)
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.saveTransVoucher(true)
                  }
                }
              },
              [_vm._v("申请")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: {
              click: function($event) {
                _vm.saveTransVoucher(false)
              }
            }
          },
          [_vm._v("保存")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("附件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39333282", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39333282","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/transVoucher/ShopDeviceTransVoucherSaveStockFifo.vue
// module id = 2574
// module chunks = 0